import { selectConfigurationState } from 'legacy/lut/features/partner360/configuration'
import { createSelector } from 'reselect'

import { selectCompetitorsSobState } from './selectCompetitorsSobState'

export const selectSobCompetitorsComment = createSelector(
  [selectCompetitorsSobState, selectConfigurationState],
  ({ comment }, { programType }) => {
    return comment[programType] || ''
  }
)
